import { useTranslation } from 'react-i18next'
import { formatCurrency } from '../../../../domain/vos/format-currency'
import { CardInfoBox } from '../../../components/card-info-box'
import { LoadingCard } from '../../../components/loading-card'

type TotalProps = {
  amount?: number
  isLoading: boolean
}

export const Total = ({ isLoading, amount }: TotalProps) => {
  const { t } = useTranslation()

  if (isLoading) {
    return <LoadingCard />
  }

  return (
    <CardInfoBox
      title={t('smartInstallmentsSummaries.total.title')}
      description={t('smartInstallmentsSummaries.total.description')}
      current={formatCurrency(amount ?? 0)}
    />
  )
}
